import { IconArrowDownward, IconArrowUpward, RadioGroup } from 'cdk-radial';
import { useSearchParams } from 'react-router-dom';

import { useStore } from 'store/store';
import styled from 'styled-components';

const Header = styled.div`
  &:hover {
    cursor: pointer;
  }
  font-weight: 600;
  font-size: 18px;
`;
const Title = styled(Header)``;
const Tags = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  align-items: center;
  b {
    margin-right: 5px;
  }
`;
const Date = styled(Header)`
  text-align: right;
  white-space: nowrap;
`;

const AnyOrEveryTag = styled(({ className, onChange, isAnyTagSet }) => {
  return (
    <RadioGroup
      className={className}
      hideLabel
      label="Tag filtering"
      name="tag-filtering"
      onChange={onChange}
      options={[
        {
          id: 'radio-any',
          label: 'Any',
          value: 'any',
        },
        {
          id: 'radio-every',
          label: 'Every',
          value: 'every',
        },
      ]}
      value={isAnyTagSet}
    />
  );
})`
  & > div {
    display: flex;
    flex-wrap: nowrap;
    label {
      padding: 0;
      height: 1rem;
      margin-top: 4px;
      margin-right: 8px;
      span {
        margin: 0;
      }
    }
  }
  span {
    transform: scale(0.75);
    width: 1.5rem;
    height: 1.5rem;
  }
  span + span {
    transform: scale(1);
  }
`;

export const ListControls = styled(({ className, isAnyTagSet }) => {
  const toggleSort = useStore((state) => state.toggleSort);
  const { type, direction } = useStore((state) => state.examplesSort);
  const [searchParams, setSearchParams] = useSearchParams();

  const titleSortDirection =
    type === 'title' ? direction === 'descending' ? <IconArrowDownward /> : <IconArrowUpward /> : '';
  const createdSortDirection =
    type === 'created' ? direction === 'descending' ? <IconArrowDownward /> : <IconArrowUpward /> : '';
  const modifiedSortDirection =
    type === 'modified' ? direction === 'descending' ? <IconArrowDownward /> : <IconArrowUpward /> : '';

  const tags = searchParams.get('tags');

  const handleOptionSelect = (event) => {
    if (tags !== null)
      if (event.target.value === 'any') setSearchParams({ any: 'true', tags });
      else setSearchParams({ tags });
    else setSearchParams({});
  };
  return (
    <div className={className}>
      <Title onClick={() => toggleSort('title')}>Title {titleSortDirection}</Title>
      <Tags>
        <b>Tags</b>{' '}
        {tags && <AnyOrEveryTag onChange={handleOptionSelect} isAnyTagSet={isAnyTagSet ? 'any' : 'every'} />}
      </Tags>
      <Date onClick={() => toggleSort('created')}>{createdSortDirection} Created</Date>
      <Date onClick={() => toggleSort('modified')}>{modifiedSortDirection} Updated</Date>
    </div>
  );
})`
  display: grid;
  grid-template-columns: calc(56% - 48px) 20% 12% 12%;
  gap: 16px;

  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[400].value};

  svg {
    width: 12px;
    height: 12px;
  }
`;
